import { lazy } from 'react';
import { DELIVERY_PERMISSIONS } from './constants';

const DeliveryListPage = lazy(() => import('./pages/DeliveryListPage'));
const DeliveryDetailPage = lazy(() => import('./pages/DeliveryDetailPage'));

export const deliveryRoutes = [
  {
    path: '/deliveries',
    element: DeliveryListPage,
    permission: DELIVERY_PERMISSIONS.READ,
    nav: { labelKey: 'nav.deliveries', icon: 'CarOutlined', group: 'commerce' },
  },
  {
    path: '/deliveries/:id',
    element: DeliveryDetailPage,
    permission: DELIVERY_PERMISSIONS.READ,
    nav: null,
  },
];
